import { Provider } from '@angular/core';

import { OrganizationApi } from '@shure/shared/angular/features/switch-organization';

import { OrganizationApiService } from './organization-api-service';

export function provideOrganizationCloud(): Provider {
	return { provide: OrganizationApi, useClass: OrganizationApiService };
}
